exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".aggrs-chart{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/divvit-app/client/views/AggreatedAttributionView/AggrChart/client/views/AggreatedAttributionView/AggrChart/style.styl","/divvit-app/client/views/AggreatedAttributionView/AggrChart/style.styl"],"names":[],"mappings":"AAAA,aACI,oBAAA,YAAA,CCCH","file":"style.styl","sourcesContent":[".aggrs-chart\n    display: flex",".aggrs-chart {\n  display: flex;\n}\n/*# sourceMappingURL=client/views/AggreatedAttributionView/AggrChart/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/views/AggreatedAttributionView/AggrChart/style.styl
// module id = 626
// module chunks = 0